import { cn } from "@/lib/utils"

interface OfferStickyCtaProps {
  label: string
  onUnlock: () => void
  purchasing?: boolean
  /** Hidden while an inline Unlock button is on screen (so it isn't duplicated). */
  hidden: boolean
}

/**
 * Unlock button pinned to the bottom of the page over a fade, visible while
 * scrolling the sales content. It hides whenever a real inline button reaches
 * the viewport so the CTA "returns to its place" in context.
 */
export function OfferStickyCta({ label, onUnlock, purchasing = false, hidden }: OfferStickyCtaProps) {
  return (
    <div
      data-slot="offer-sticky-cta"
      aria-hidden={hidden}
      className={cn(
        "pointer-events-none fixed inset-x-0 bottom-0 z-40 mx-auto flex w-full max-w-app flex-col items-center bg-gradient-to-b from-transparent to-dark-base px-5 pb-5 pt-10 transition-opacity duration-200",
        hidden ? "opacity-0" : "opacity-100",
      )}
    >
      <button
        type="button"
        onClick={onUnlock}
        disabled={purchasing || hidden}
        className={cn(
          "flex h-14 w-[382px] max-w-full items-center justify-center gap-1 rounded-full text-base font-semibold transition-opacity",
          purchasing
            ? "bg-purple-light/10 text-purple-light/70"
            : "bg-gradient-to-b from-peach to-purple-accent text-white hover:opacity-90",
          hidden ? "pointer-events-none" : "pointer-events-auto",
        )}
      >
        {purchasing ? (
          <>
            <span className="size-5 animate-spin rounded-full border-2 border-purple-light border-t-transparent" />
            Processing…
          </>
        ) : (
          label
        )}
      </button>
    </div>
  )
}
